import customLog from './custom-log';

export default {
  userLabel: 'userCode',
  userService: '/users',
  ...customLog,
};
